// libraries.
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// slices.
import { apiBudgetRoute } from "../apiSlices";

// interfaces.
import { ModelError } from "../interfaces/interfaces";
import { RulesSchema } from "./interfaces/rawRules.interfaces";

// ─── Types ────────────────────────────────────────────────────────────────────

// Normalized item used throughout the app.
export interface SubRutaItem {
  id: number;
  name: string;
}

// Raw shape returned by the API.
interface RawSubRutaItem {
  id: number;
  label: string;
  is_active: "active" | "inactive";
}

interface SubRutasApiResponse {
  success: boolean;
  data: {
    sub_rutas: RawSubRutaItem[];
    total: number;
  };
  message: string;
}

interface GetSubRutasParams {
  schema: RulesSchema;
}

// ─── Endpoint ─────────────────────────────────────────────────────────────────

export const subRutasEndpoints = apiBudgetRoute.injectEndpoints({
  endpoints: (builder) => ({
    getSubRutas: builder.query<SubRutaItem[], GetSubRutasParams>({
      query: ({ schema }) => `/rules/sub-rutas?schema=${schema}`,
      transformResponse: (raw: SubRutasApiResponse) =>
        raw.data.sub_rutas
          .filter((s) => s.is_active === "active")
          .map((s) => ({ id: s.id, name: s.label })),
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "getSubRutas",
        };
        return modelError;
      },
    }),
  }),
});

export const { useGetSubRutasQuery, useLazyGetSubRutasQuery } = subRutasEndpoints;
